import { Documento } from '../services/documentoService';

export const PLANO_CACADOR_GRATIS = 'Caçador Grátis';
export const TIPO_DOCUMENTO_UNICO = 'CR';

/** Associado = data_valido_ate vigente (mesma regra do backend). */
export const ehAssociado = (dataValidoAte?: string | null): boolean => {
  if (!dataValidoAte) return false;
  const raw = dataValidoAte.includes('T') ? dataValidoAte : `${dataValidoAte}T12:00:00`;
  const ate = new Date(raw);
  if (Number.isNaN(ate.getTime())) return false;
  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0);
  ate.setHours(0, 0, 0, 0);
  return ate >= hoje;
};

export const ehPlanoPago = (plano?: string | null): boolean =>
  plano === 'Caçador Padrão' || plano === 'Caçador Temporada';

/** Grátis: 1 por tipo. Pago: vários, exceto CR (sempre 1). */
export const podeAdicionarDocumento = (
  plano: string | undefined | null,
  tipo: string,
  quantidade: number,
): boolean => {
  if (tipo === TIPO_DOCUMENTO_UNICO) return quantidade < 1;
  if (!plano) return true;
  if (!ehPlanoPago(plano)) return quantidade < 1;
  return true;
};

/** Grátis: só o primeiro documento cadastrado de cada tipo. */
export const documentosVisiveisParaSocio = (
  plano: string | undefined | null,
  documentos: Documento[],
): Documento[] => {
  if (ehPlanoPago(plano)) return documentos;

  const porTipo = new Map<string, Documento>();
  for (const doc of documentos) {
    const tipo = doc.tipo_documento;
    const atual = porTipo.get(tipo);
    if (!atual) {
      porTipo.set(tipo, doc);
      continue;
    }
    const uploadDoc = doc.data_upload ? new Date(doc.data_upload).getTime() : Number.MAX_SAFE_INTEGER;
    const uploadAtual = atual.data_upload ? new Date(atual.data_upload).getTime() : Number.MAX_SAFE_INTEGER;
    const idDoc = doc.id ?? Number.MAX_SAFE_INTEGER;
    const idAtual = atual.id ?? Number.MAX_SAFE_INTEGER;
    if (uploadDoc < uploadAtual || (uploadDoc === uploadAtual && idDoc < idAtual)) {
      porTipo.set(tipo, doc);
    }
  }
  return Array.from(porTipo.values());
};

type AnuidadePlano = {
  plano?: string | null;
  status?: string;
  ano?: number;
  data_vencimento?: string;
};

/** Plano vigente do caçador (anuidade paga mais recente, senão a última lançada). */
export const planoDoCacador = (
  anuidades: AnuidadePlano[],
  dataValidoAte?: string | null,
): string => {
  const pagas = anuidades.filter((a) => a.status === 'Pago');
  const lista = pagas.length > 0 ? pagas : anuidades;
  const ordenadas = [...lista].sort((a, b) => {
    const vencimento = String(b.data_vencimento || '').localeCompare(String(a.data_vencimento || ''));
    if (vencimento !== 0) return vencimento;
    return (b.ano || 0) - (a.ano || 0);
  });
  const atual = ordenadas[0];
  if (atual?.plano) return atual.plano;
  return ehAssociado(dataValidoAte) ? 'Caçador Padrão' : PLANO_CACADOR_GRATIS;
};
